<div class="modal active">
  <div class="modal__container">
    <div class="fields">
      <h2>Configuration Color Settings</h2>
      <div class="close" (click)="bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <div class="fields__block">
          <div class="tab">
            <button class="tablinks" (click)="openTab($event, 'Navaids')" id="defaultOpen">NavAid</button>
            <button class="tablinks" (click)="openTab($event, 'Coordinate Points')">Coordinate Points</button>
            <button class="tablinks" (click)="openTab($event, 'Air Space Boundary')">Airspace</button>
          </div>

          <div id="Navaids" class="tabcontent">
            <div  *ngFor="let key of getObjectKeys(configurationColorService.colorOfTypesChange.navaidColors);let j = index">
              <div *ngFor="let color of configurationColorService.colorOfTypesChange.navaidColors[key]; let i = index">
                <input type="color" list="presetColors" class="input-color"  name="navaidcolor_{{j}}_{{i}}" [(ngModel)]="configurationColorService.colorOfTypesChange.navaidColors[key][i].color">
                <datalist id="presetColors">
                  <option value="#ff0000">
                  <option value="#FFFF00">
                  <option value="#66FF66">
                  <option value="#00ff00">
                  <option value="#00ffff">
                  <option value="#0000ff">
                  <option value="#FFC0CB">
                  <option value="#C8A2C8">
                </datalist>
                <p>{{key.toUpperCase() + " " +( i == 0 ? "Published" : "User Defined")}}</p>
              </div>
            </div>
          </div>
          <div id="Coordinate Points" class="tabcontent">
            <div  *ngFor="let key of getObjectKeys(configurationColorService.colorOfTypesChange.coordinatePointColors);let j = index">
              <div *ngFor="let color of configurationColorService.colorOfTypesChange.coordinatePointColors[key]; let i = index">
                <input type="color" list="presetColors"
                 [(ngModel)]="configurationColorService.colorOfTypesChange.coordinatePointColors[key][i].color" name="cpcolor_{{j}}_{{i}}" >
                <datalist id="presetColors">
                  <option value="#ff0000">
                  <option value="#FFFF00">
                  <option value="#66FF66">
                  <option value="#00ff00">
                  <option value="#00ffff">
                    <option value="#0000ff">
                  <option value="#FFC0CB">
                      <option value="#C8A2C8">
                </datalist>
                <p>{{key.toUpperCase() + " " +( i == 0 ? "Published" : "User Defined")}}</p>
              </div>
            </div>
          </div>


            <div id="Air Space Boundary" class="tabcontent">
              <div>

                <input type="color" list="presetColors" [(ngModel)]="configurationColorService.colorOfTypesChange.airspaceColor"  name="airspaceColor">
                <datalist id="presetColors">
                  <option value="#ff0000">
                    <option value="#FFFF00">
                      <option value="#66FF66">
                        <option value="#00ff00">
                          <option value="#00ffff">
                            <option value="#0000ff">
                              <option value="#FFC0CB">
                                <option value="#C8A2C8">
                                </datalist>
                                <p>AirSpace Boundaries</p>
                              </div>
                            </div>



          <div class="fields__btn">
            <button href="#" type="submit" value="Save" class='blue'  (click)="applyChange(this.tabOpened)">Apply</button>
            <button href="#" type="submit" value="Save" class='blue'  (click)="restore(this.tabOpened)">Restore</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
